export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_07.872bfd8e.jpg";